import gql from 'graphql-tag';

export const propertyInsightsQuery = gql`
  query PropertyInsights($propertyId: ID!) {
    propertyInsights(propertyId: $propertyId)
  }
`;

/** Same, limited to some kinds; older backends reject the argument. */
export const propertyInsightsOfKindsQuery = gql`
  query PropertyInsightsOfKinds(
    $propertyId: ID!
    $kinds: [PropertyInsightKindInput!]
  ) {
    propertyInsights(propertyId: $propertyId, kinds: $kinds)
  }
`;

/**
 * Same, with the `summaryKinds` snapshots returned without `payload.items`
 * (`payload.itemsTotal` instead); page those with `propertyInsightItemsQuery`.
 */
export const propertyInsightsSummaryQuery = gql`
  query PropertyInsightsSummary(
    $propertyId: ID!
    $kinds: [PropertyInsightKindInput!]
    $summaryKinds: [PropertyInsightKindInput!]
  ) {
    propertyInsights(
      propertyId: $propertyId
      kinds: $kinds
      summaryKinds: $summaryKinds
    )
  }
`;

/** A page of one snapshot's `payload.items`, filtered by top-level field equality. */
export const propertyInsightItemsQuery = gql`
  query PropertyInsightItems(
    $propertyId: ID!
    $kind: PropertyInsightKindInput!
    $filter: JSON
    $first: Int!
    $offset: Int!
  ) {
    propertyInsightItems(
      propertyId: $propertyId
      kind: $kind
      filter: $filter
      first: $first
      offset: $offset
    ) {
      items
      total
      hasMore
    }
  }
`;

export const propertyGrowthQuery = gql`
  query PropertyGrowth($propertyId: ID!, $days: Int) {
    propertyGrowth(propertyId: $propertyId, days: $days)
  }
`;
